"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _tinymce = _interopRequireDefault(require("tinymce/tinymce"));
var _TinymceEditor = _interopRequireDefault(require("../TinymceEditor"));
var _context = require("../TinymceEditor/context");
var _constants = require("../TinymceEditor/constants");
var _HiddenQuotationButton = require("./HiddenQuotationButton");
var _utils = require("./utils");
var _hotkey = require("../TinymceEditor/hotkey");
var _utils2 = require("../TinymceEditor/utils");
require("./index.css");
var _SuggestionTagContainer = _interopRequireDefault(require("../TinymceEditor/components/SuggestionTagContainer"));
var _ComposeBodyDropZone = _interopRequireDefault(require("./ComposeBodyDropZone"));
var _SpellcheckTagContainer = _interopRequireDefault(require("../TinymceEditor/components/SpellcheckTagContainer"));
var _utils3 = require("../../utils");
var _autolinker = _interopRequireDefault(require("../../utils/autolinker"));
var _excluded = ["defaultHTML", "signature", "linkDialogRef", "bottomRef", "headerRef", "suggestions", "hiddenQuoteButton", "enableSplitQuotation", "spellCheck", "autoLink", "onEditorChange", "onLoadInlineImage", "onLoadExternalImage", "onUploadInlineImage", "onUploadAttachments", "onSpellCheck", "onFocus"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var $ = _tinymce["default"].dom.DomQuery;
function TinymceComposeEditor(_ref, ref) {
  var _ref$defaultHTML = _ref.defaultHTML,
    defaultHTML = _ref$defaultHTML === void 0 ? '' : _ref$defaultHTML,
    _ref$signature = _ref.signature,
    signature = _ref$signature === void 0 ? '' : _ref$signature,
    linkDialogRef = _ref.linkDialogRef,
    bottomRef = _ref.bottomRef,
    headerRef = _ref.headerRef,
    _ref$suggestions = _ref.suggestions,
    suggestions = _ref$suggestions === void 0 ? [] : _ref$suggestions,
    _ref$hiddenQuoteButto = _ref.hiddenQuoteButton,
    hiddenQuoteButton = _ref$hiddenQuoteButto === void 0 ? false : _ref$hiddenQuoteButto,
    _ref$enableSplitQuota = _ref.enableSplitQuotation,
    enableSplitQuotation = _ref$enableSplitQuota === void 0 ? false : _ref$enableSplitQuota,
    _ref$spellCheck = _ref.spellCheck,
    spellCheck = _ref$spellCheck === void 0 ? false : _ref$spellCheck,
    _ref$autoLink = _ref.autoLink,
    autoLink = _ref$autoLink === void 0 ? false : _ref$autoLink,
    _ref$onEditorChange = _ref.onEditorChange,
    onEditorChange = _ref$onEditorChange === void 0 ? _noop["default"] : _ref$onEditorChange,
    _ref$onLoadInlineImag = _ref.onLoadInlineImage,
    onLoadInlineImage = _ref$onLoadInlineImag === void 0 ? _noop["default"] : _ref$onLoadInlineImag,
    _ref$onLoadExternalIm = _ref.onLoadExternalImage,
    onLoadExternalImage = _ref$onLoadExternalIm === void 0 ? _noop["default"] : _ref$onLoadExternalIm,
    _ref$onUploadInlineIm = _ref.onUploadInlineImage,
    onUploadInlineImage = _ref$onUploadInlineIm === void 0 ? _noop["default"] : _ref$onUploadInlineIm,
    _ref$onUploadAttachme = _ref.onUploadAttachments,
    onUploadAttachments = _ref$onUploadAttachme === void 0 ? _noop["default"] : _ref$onUploadAttachme,
    _ref$onSpellCheck = _ref.onSpellCheck,
    onSpellCheck = _ref$onSpellCheck === void 0 ? _noop["default"] : _ref$onSpellCheck,
    onFocus = _ref.onFocus,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var editor = (0, _context.useEditor)();
  var editorRef = (0, _react.useRef)();
  var scrollParentNodeRef = (0, _react.useRef)();
  var noNeedSplitQuotation = (0, _react.useMemo)(function () {
    return enableSplitQuotation ? (0, _utils.isOpenQuotation)(defaultHTML) : true;
  }, []);
  var editorHTML = (0, _react.useMemo)(function () {
    return noNeedSplitQuotation ? defaultHTML : (0, _utils.getEditorHTML)(defaultHTML);
  }, []);
  var quotationHTML = (0, _react.useMemo)(function () {
    return noNeedSplitQuotation ? '' : (0, _utils.getQuotationHTML)(defaultHTML);
  }, []);
  var initialSignatureRef = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (!editor || !signature) return;
    if (initialSignatureRef.current) {
      initialSignatureRef.current = false;
      return;
    }
    var signatureNodes = editor.dom.select('div.webmail_signature');
    if (signatureNodes.length === 0) return;
    var newSignatureNode = editor.dom.create('div', {
      "class": 'webmail_signature'
    }, signature);
    editor.dom.replace(newSignatureNode, signatureNodes[0]);
    editor.fire('change');
  }, [editor, signature]);
  var showQuotationRef = (0, _react.useRef)(!quotationHTML);
  var handleShowHiddenQuotation = function handleShowHiddenQuotation() {
    showQuotationRef.current = true;
    var $ = _tinymce["default"].dom.DomQuery;
    var body = editor.getBody();
    var bookmark = editor.selection.getBookmark();
    $(body).wrapInner('<div class="webmail_original">');
    editor.selection.setContent(quotationHTML);
    editor.selection.moveToBookmark(bookmark);
    editor.undoManager.reset();
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      insertLink: function insertLink() {
        return _hotkey.Hotkeys.Link.command(editor, linkDialogRef);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!editor) return;

    //scroll into view
    editor.on('SelectionChange', function () {
      var _editor$selection;
      if (!(editor !== null && editor !== void 0 && (_editor$selection = editor.selection) !== null && _editor$selection !== void 0 && _editor$selection.isCollapsed())) return;
      var container = editor.getContainer();
      var range = editor.selection.getRng();
      var rects = range.getClientRects();
      if (!rects.length) return;
      if (!(bottomRef && bottomRef.current) || !(headerRef && headerRef.current)) {
        return;
      }
      if (!scrollParentNodeRef.current) {
        scrollParentNodeRef.current = (0, _utils3.getScrollParent)(container);
      }
      var parentNode = scrollParentNodeRef.current;
      if (!parentNode) return;
      var domRect = range.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var domTop = domRect.top + containerRect.top;
      var domBottom = domRect.bottom + containerRect.top;
      if (bottomRef && bottomRef.current) {
        var bottomRect = bottomRef.current.getBoundingClientRect();
        if (bottomRect.top < domBottom) {
          return parentNode.scrollTo({
            top: parentNode.scrollTop + domBottom - bottomRect.top
          });
        }
      }
      if (headerRef && headerRef.current) {
        var headerRect = headerRef.current.getBoundingClientRect();
        if (headerRect.bottom > domTop) {
          return parentNode.scrollTo({
            top: parentNode.scrollTop + domTop - headerRect.bottom
          });
        }
      }
    });
    editor.on('focus', onFocus);
  }, [editor]);
  var handleEditorChange = function handleEditorChange(html) {
    if (showQuotationRef.current) {
      onEditorChange(html);
    } else {
      onEditorChange(html + quotationHTML);
    }
  };
  var handleUploadFiles = function handleUploadFiles(files, editor) {
    if ((0, _toConsumableArray2["default"])(files).every(function (item) {
      return _constants.INLINE_IAMGE_MIME_TYPES.includes(item.type);
    })) {
      (0, _utils2.uploadInlineImages)(editor, files, onUploadInlineImage);
    } else {
      onUploadAttachments(files);
    }
  };
  var handleInit = (0, _react.useCallback)(function (editor) {
    var browser = _tinymce["default"].Env.browser;
    if (autoLink) {
      var _editor$contentWindow;
      var contentBody = (_editor$contentWindow = editor.contentWindow) === null || _editor$contentWindow === void 0 ? void 0 : _editor$contentWindow.document.body;
      // converts the URL-like text to <a> tag
      contentBody && (0, _autolinker["default"])(contentBody);
    }
    if (browser.isFirefox()) {
      //tabindex=-1 not working
      var node = document.querySelector('.MuiDialog-container.MuiDialog-scrollPaper');
      node && node.removeAttribute('tabindex');
    }
    editor.on('keydown', function (event) {
      if (event.key === 'Tab' && !event.isComposing) {
        if (event.shiftKey) return;
        var suggestionSpan = $('#autosuggest-tag', editor.getContainer());
        if (suggestionSpan.length) {
          event.preventDefault();
          editor.insertContent(suggestionSpan[0].textContent);
        }
      }
    });
    editor.on('BeforeAddUndo', function (event) {
      var level = event.level;
      if ((0, _utils2.isAddingUndoLevelWithPlaceholderImg)(level.content)) {
        event.preventDefault();
      }
    });
  }, [spellCheck, autoLink]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_TinymceEditor["default"], (0, _extends2["default"])({
    ref: editorRef,
    linkDialogRef: linkDialogRef,
    defaultHTML: noNeedSplitQuotation ? defaultHTML : editorHTML,
    onEditorChange: handleEditorChange,
    onLoadInlineImage: onLoadInlineImage,
    onLoadExternalImage: onLoadExternalImage,
    onUploadFiles: handleUploadFiles,
    onInit: handleInit
  }, rest)), !!editor && spellCheck && !!onSpellCheck && /*#__PURE__*/_react["default"].createElement(_SpellcheckTagContainer["default"], {
    onSpellCheck: onSpellCheck
  }), !!editor && !!suggestions.length && /*#__PURE__*/_react["default"].createElement(_SuggestionTagContainer["default"], {
    suggestions: suggestions
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-shrink-0"
  }, !hiddenQuoteButton && !noNeedSplitQuotation && /*#__PURE__*/_react["default"].createElement(_HiddenQuotationButton.HiddenQuotationButton, {
    onClick: handleShowHiddenQuotation
  })), /*#__PURE__*/_react["default"].createElement(_ComposeBodyDropZone["default"], {
    bottomRef: bottomRef,
    headerRef: headerRef
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.forwardRef)(TinymceComposeEditor);
//# sourceMappingURL=index.js.map